import PropTypes from 'prop-types';
// material
import { Box, Grid, Typography, Divider, Skeleton, Stack } from '@mui/material';
import { MHidden } from '../../@material-extend';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

let TOTAL = 0;

if (process.env.REACT_APP_ENVIRONMENT === 'development') TOTAL = 800;

SoundBoxStatsItem.propTypes = {
  statsData: PropTypes.object
};

export default function SoundBoxStatsItem({ statsData }) {
  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-around" sx={{ minHeight: '7vh' }}>
        <Grid size={{ xs: 12, sm: 5.5, md: 5.5 }} pl={0}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}
          >
            {statsData?.totalSum !== undefined && statsData?.totalSum !== null ? (
              <>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#6F6F6F',
                    fontSize: { md: '22px', xs: '20px', lg: '26px' },
                    textAlign: 'center',
                    lineHeight: '30px',
                    fontFamily: 'Montserrat'
                  }}
                >
                  Rs. {fShortenNumber(statsData?.totalSum)}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: '14px',
                    lineHeight: '14px',
                    textAlign: 'center'
                  }}
                >
                  Total Amount
                </Typography>
              </>
            ) : (
              <Skeleton variant="text" sx={{ height: '80px', width: '100px' }} />
            )}
          </Stack>
        </Grid>

        <MHidden width="smDown">
          <Grid size={{ xs: 0.3, sm: 0.3 }}>
            <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} orientation="vertical" />
          </Grid>
        </MHidden>

        <Grid size={{ xs: 12, sm: 5.5, md: 5.5 }} pl={0}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%' }}
          >
            {statsData?.totalSum !== undefined && statsData?.totalSum !== null ? (
              <>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#6F6F6F',
                    fontSize: { md: '22px', xs: '20px', lg: '26px' },
                    textAlign: 'center',
                    lineHeight: '30px',
                    fontFamily: 'Montserrat'
                  }}
                >
                  {fShortenNumber(statsData?.totalCount)}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#171D40',
                    fontSize: '14px',
                    lineHeight: '14px',
                    textAlign: 'center'
                  }}
                >
                  Total no. of Transactions{' '}
                </Typography>
              </>
            ) : (
              <Skeleton variant="text" sx={{ height: '80px', width: '100px', ml: 2, mt: -2 }} />
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}